export class InventoryRawPurchase {
    productName: string;
    supplierName: string;
    billNumber: string;
    purchaseRate: string;
    quantity: string;
    batchNumber: string;
    expiryDate: string;
}